export const specialTicketTypes = [];
